const DataDialog = ({ open, message,
  width,
  title = "Response",
  onCancel }) => {
  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    },
    dialog: {
      background: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: width ? width : "90vw",
      boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
      maxWidth: '699px',
      maxHeight: '90vh',
      position: 'relative',
      overflow: 'hidden'
    },
    actions: {
      marginTop: "20px",
      textAlign: "right",
    },
    button: {
      position: 'absolute',
      top: '-5px',
      right: '10px'
    },
    pre: {
      maxHeight: '90vh',
      overflow: 'auto',

    }
  };
  if (!open) return null;

  return (
    <div style={styles.backdrop}>


      <div style={styles.dialog}>
        <button style={styles.button} className="btn btn-primary" onClick={onCancel} >
          X
        </button>
        <h3 className="font-bold mb-4 text-xl">{title}</h3>
        {(typeof message === 'string') && (
          <div dangerouslySetInnerHTML={{ __html: message }}></div>
        )}
        {(typeof message !== 'string') && (
          <pre style={styles.pre}>{JSON.stringify(message, null, 2)}</pre>
        )}


      </div>
    </div>
  );
}


export default DataDialog;